import React from "react";
import { Link, useParams } from "react-router-dom";
import { UserOutlined, LogoutOutlined, DashboardOutlined } from "@ant-design/icons";
import { PublicCareerSettings, hexAlpha } from "../../types";

interface CareerNavbarProps {
  settings: PublicCareerSettings | null;
  guestToken: string | null;
  onLoginClick: () => void;
  onLogoutClick: () => void;
}

const CareerNavbar: React.FC<CareerNavbarProps> = ({
  settings,
  guestToken,
  onLoginClick,
  onLogoutClick,
}) => {
  const { career_page_uuid } = useParams<{ career_page_uuid: string }>();
  const primary = settings?.primary_color || "#4f46e5";

  return (
    <nav style={{
      position: "sticky", top: 0, zIndex: 100,
      background: "rgba(255,255,255,0.95)",
      backdropFilter: "blur(12px)",
      borderBottom: "1px solid #e8eaed",
      padding: "0 40px",
      height: 64,
      display: "flex", alignItems: "center", justifyContent: "space-between",
      boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
    }}>
      
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Link to={`/careers/${career_page_uuid || ""}`}></Link>
        {settings?.company_logo_url ? (
          <Link to={`/careers/${career_page_uuid || ""}`}>
            <img
              src={settings.company_logo_url}
              alt={settings.company_name}
              style={{ height: 36, width: 36, objectFit: "contain", borderRadius: 8, border: "1px solid #f0f0f0" }}
            />
          </Link>
        ) : (
          <Link to={`/careers/${career_page_uuid || ""}`}>
            <div style={{
              height: 36, width: 36, borderRadius: 8,
              background: hexAlpha(primary, 0.12),
              color: primary, fontWeight: 700, fontSize: 16,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              {settings?.company_name?.[0]?.toUpperCase()}
            </div>
          </Link>
        )}
        <Link to={`/careers/${career_page_uuid || ""}`}>
          <span style={{ fontWeight: 700, fontSize: 15, color: "#1a1a2e", letterSpacing: "-0.2px" }}>
            {settings?.company_name || "Careers"}
          </span>
        </Link>
      </div>

      
      {guestToken ? (
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Link
            to={`/careers/${career_page_uuid || ""}/profile`}
            style={{
              display: "flex", alignItems: "center", gap: 6,
              color: "#555", textDecoration: "none", fontSize: 13, fontWeight: 500,
            }}
          >
            <DashboardOutlined /> My Dashboard
          </Link>
          <button
            onClick={onLogoutClick}
            style={{
              display: "flex", alignItems: "center", gap: 6,
              padding: "7px 16px", borderRadius: 20,
              border: "1px solid #ffcdd2", background: "#fff5f5",
              color: "#e53935", fontSize: 13, fontWeight: 500, cursor: "pointer",
            }}
          >
            <LogoutOutlined /> Logout
          </button>
        </div>
      ) : (
        <button
          onClick={onLoginClick}
          style={{
            display: "flex", alignItems: "center", gap: 7,
            padding: "8px 20px", borderRadius: 20, border: "none",
            background: primary, color: "#fff",
            fontSize: 13, fontWeight: 600, cursor: "pointer",
            boxShadow: `0 4px 12px ${hexAlpha(primary, 0.35)}`,
          }}
        >
          <UserOutlined /> Login / Create Profile
        </button>
      )}
    </nav>
  );
};

export default CareerNavbar;
